import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutFooterDefault from "./Layouts/LayoutDefault/CheckoutFooterDefault"
import CheckoutFooter2 from "./Layouts/Layout2/CheckoutFooter2"
import React from "react"
import CheckoutFooter3 from "./Layouts/Layout3/CheckoutFooter3"
import CheckoutFooter4 from "./Layouts/Layout4/CheckoutFooter4"
import CheckoutFooter5 from "./Layouts/Layout5/CheckoutFooter5"
import CheckoutFooter6 from "./Layouts/Layout6/CheckoutFooter6"
import CheckoutFooter7 from "./Layouts/Layout7/CheckoutFooter7"
import CheckoutFooter8 from "./Layouts/Layout8/CheckoutFooter8"

interface ICheckoutFooter {
  layout?: TCheckoutLayout
  tenantName?: string
  setOpenTermsPurchase: (value: boolean) => void
}

const CheckoutFooter = ({
  layout,
  tenantName,
  setOpenTermsPurchase,
}: ICheckoutFooter) => {
  if (!layout) return <></>

  const checkoutFooterData = {
    [TCheckoutLayout.Default]: (
      <CheckoutFooterDefault
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout2]: (
      <CheckoutFooter2
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout3]: (
      <CheckoutFooter3
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout4]: (
      <CheckoutFooter4
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout5]: (
      <CheckoutFooter5
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout6]: (
      <CheckoutFooter6
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout7]: (
      <CheckoutFooter7
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
    [TCheckoutLayout.Layout8]: (
      <CheckoutFooter8
        tenantName={tenantName}
        setOpenTermsPurchase={setOpenTermsPurchase}
      />
    ),
  }

  return checkoutFooterData[layout] || <></>
}

export default CheckoutFooter
